import { Icon } from '@blueprintjs/core'
import React from 'react'
import { Layout } from '../Layout'
import { Button } from '../ui/button'
import { EmptyState } from '../ui/empty-state'

export const NotFound = () => {
    const listOfDescriptions = [
        'Oops! Looks like the page you were searching for has gone on an impromptu vacation, leaving us all a bit puzzled.',
        "Oops! It seems our hyperactive hamster ran off with the page you were looking for. We're putting out an APB (All Pages Bulletin) to bring it back!",
        "Whoopsie daisy! The page you're seeking seems to have escaped to a secret hideout. Our crack team of web explorers is on the case to bring it back to the digital realm!",
        "Houston, we have a problem! It appears the page you're searching for has embarked on an intergalactic adventure. Our rocket scientists are working tirelessly to retrieve it from the depths of the cosmos.",
        "Uh-oh! It seems the page you're hunting for got caught up in a game of hide-and-seek with our mischievous website gnomes. We're rounding up their shenanigans and coaxing them to reveal its whereabouts!",
        "Oh no! The page you're after must have taken a spontaneous vacation to a tropical island. Don't worry, we're sending a virtual postcard to persuade it to return to its rightful place on our website. Hang tight and enjoy the virtual sunshine while we sort things out!",
    ]

    const GoHomeButton = () => {
        const onClick = () => {
            window.location.href = '/'
        }

        return <Button onClick={onClick} icon="home" text="Go Home" outlined intent="primary" />
    }

    return (
        <Layout>
            <div style={{ height: 600 }} className="flex items-center">
                <EmptyState
                    icon={<Icon icon="warning-sign" size={64} color="#CDD6DF" />}
                    title={<span className="text-mjDark-1400 text-4xl">Page Not Found</span>}
                    description={
                        <span className="text-xs text-mjDark-1400">
                            {
                                listOfDescriptions[
                                    Math.floor(Math.random() * listOfDescriptions.length)
                                ]
                            }
                        </span>
                    }
                    action={<GoHomeButton />}
                />
            </div>
        </Layout>
    )
}
